<template>
  <!-- 规章制度-->
  <div id="Admiscrit">
      <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{ name: 'home' }">首页</router-link></span>
         <i class="iconfont icon-youjiantou"></i>
        <span ><router-link :to="{name:'aa'}">协会概况</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
        <span
          ><router-link :to="{ name: 'Assocwindow' }"
            >规章制度</router-link
          ></span
        >
      </div>
    <ul class="historyList">
      <li v-for="(item,index) in historyList" :key="index" >
        <!-- <div class="historyListLeft">
          <div v-html="item.Title" class="historyListLeft_title" style="font-size:19px;"></div>
          <div class="historyListLeft_circle"></div>
        </div>
        <div class="historyListcircle"></div> -->
        <div class="historyListRight">
          <div v-html="item.Abstruct" class="historyListRight_abs"></div>
          <p v-html="item.Content" style="text-indent: 2em;"></p>
        </div>
        <div style="clear:both;"></div>
      </li>
      <!-- <div class="historyListDiv"></div> -->
      <div style="clear:both;"></div>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name:'Admiscrit',
  data(){
    return{
      historyList:[]
    }
  },
  components:{

  },
  methods:{
    getData(){
      axios.post('/SiteContentAPI/GetPageList',{
        ChannelID:2831,
        JournalID:202007100001,
        CurrentPage:1,
        PageSize:8
      }).then((res) => {
        this.historyList = res.data._itemList
      })
    }
  },
  created(){
    this.getData();
  }
}
</script>

<style lang="less" scoped>
  #Admiscrit{
    width:100%;
    height:100%;
    margin:0 auto;
    position: relative;
          .crumbs {
    width: 1200px;
    height: 20px;
    position: relative;
    text-align: left;
    margin-top: 24px;
    margin-bottom: 20px;
    // margin-left: 2%;
    line-height: 20px;
    span:nth-child(2) a {
      color: #000000;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
    i {
      color: #767c82;
      font-size: 18px;
      margin-left: 10px;
      font-weight: bold;
    }
    i:nth-child(1) {
      color: #000;
      margin-right: 5px;
    }
     span:nth-child(4) a {
      color: #000;
      font-size: 16px;
      margin-left: 10px;
      font-weight: bold;
      cursor: pointer;
    }
    span:nth-child(6) a {
      color: #c01b22;
      font-size: 16px;
      margin-left: 10px;
      font-weight: bold;
      cursor: pointer;
    }
  }
    .historyList{
      width: 100%;
      height: 100%;
      li{
        list-style: none;
        width: 100%;
        margin-bottom: 15px;
        position: relative;
      }
    }
    .historyListLeft{
      width: 110px;
      float: left;
      .historyListLeft_title{
        width: 92px;
        height: 32px;
        border-radius: 5px;
        background:#C01B22;
        text-align: center;
        color: #FFFFFF!important;
        font-size: 16px;
        line-height: 32px;
        margin-top: 11px;
        /deep/p{
          color: #FFFFFF!important;
          font-size: 16px!important;
        }
      }
    }
    .historyListDiv{
      width: 1px;
      height: 100%;
      border: 1px solid #D0CBCB;
      position: absolute;
      top: 0;
      left: 112px;
    }
    .historyListcircle{
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background: #CDB47C;
      position: relative;
      left: 12%;
      top: 18px;
      z-index: 999;
    }
    .historyListRight{
      width: 100%;
      // height: 65px;
      // float: right;
      .historyListRight_abs{
        font-size: 19px;
      }
      p{
        font-size:18px!important;
        color:#000!important;
        margin-top:26px;
        text-indent:2em;
        text-align:center;
        line-height:33px!important;
        text-align: justify;
        /deep/p{
          font-size:18px!important;
          color:#000!important;
          margin-top:18px!important;
          text-align:center!important;
          line-height:33px!important;
          text-align: justify!important;
        }
        /deep/span{
          font-size:18px!important;
          color:#000!important;
          margin-top:18px!important;
          text-align:center!important;
          line-height:33px!important;
          text-align: justify!important;
        }
      }
    }
    ul{
      width: 100%;
      // height: 500px;
      li{
        margin-bottom: 15px;
        // margin-left: 15px;
        list-style:none;
        div{
          color: #000;
          font-size: 17px;
        }
        /deep/p{
          color:#000;
          font-size: 17px;
          /deep/span{
            font-size: 17px!important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Assocwindow/Admiscrit/index.vue